module.exports = __webpack_public_path__ + "static/media/coffee_image_card_beans_in_hands_tablet.26044870.jpg";